export default __webpack_public_path__ + "static/media/link-url-icon.9f6798b9.svg";